import { useState, useEffect } from 'react';

function useIsBetweenBreakpoints(initialValue: number, finalValue: number) {
  const [isBetweenBreakpoints, setIsBetweenBreakpoints] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsBetweenBreakpoints(window.innerWidth >= initialValue && window.innerWidth <= finalValue);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [finalValue, initialValue]);

  return isBetweenBreakpoints;
}

export default useIsBetweenBreakpoints;
